
const languagePack: any = {
    "검색어를 입력해주세요.": {
        "ko": "검색어를 입력해주세요.",
        "id": "Silakan masukkan kata kunci Anda.",
        "fr": "Veuillez entrer votre mot-clé.",
        "es": "Por favor, introduzca su palabra clave.",
        "zh": "请输入您的搜索词。",
        "ja": "検索キーワードを入力してください。",
        "en": "Please enter your search term.",
        "de": "Bitte geben Sie Ihren Suchbegriff ein.",
        "it": "Inserisci il termine di ricerca.",
        "ru": "Пожалуйста, введите ключевое слово.",
        "tr": "Lütfen arama teriminizi girin.",
        "pt": "Por favor, insira sua palavra-chave.",
        "th": "โปรดใส่คำค้นหาของคุณ"
    }, "장바구니": {
        "ko": "장바구니",
        "id": "Keranjang",
        "fr": "Panier",
        "es": "Carrito",
        "zh": "购物车",
        "ja": "カート",
        "en": "Cart",
        "de": "Warenkorb",
        "it": "Carrello",
        "ru": "Корзина",
        "tr": "Sepet",
        "pt": "Carrinho",
        "th": "ตะกร้าสินค้า"
    },
    "설정": {
        "ko": "설정",
        "id": "Pengaturan",
        "fr": "Paramètres",
        "es": "Configuración",
        "zh": "设置",
        "ja": "設定",
        "en": "Settings",
        "de": "Einstellungen",
        "it": "Impostazioni",
        "ru": "Настройки",
        "tr": "Ayarlar",
        "pt": "Configurações",
        "th": "การตั้งค่า"
    },
    "크리에이터": {
        "ko": "크리에이터",
        "id": "Pembuat konten",
        "fr": "Créateur",
        "es": "Creador",
        "zh": "创作者",
        "ja": "クリエイター",
        "en": "Creator",
        "de": "Kreator",
        "it": "Creatore",
        "ru": "Создатель",
        "tr": "Yaratıcı",
        "pt": "Criador",
        "th": "ผู้สร้าง"
    },
    "제거": {
        "ko": "제거",
        "id": "Hapus",
        "fr": "Supprimer",
        "es": "Eliminar",
        "zh": "删除",
        "ja": "削除",
        "en": "Remove",
        "de": "Entfernen",
        "it": "Rimuovi",
        "ru": "Удалить",
        "tr": "Kaldır",
        "pt": "Remover",
        "th": "ลบ"
    },
    "결제": {
        "ko": "결제",
        "id": "Pembayaran",
        "fr": "Paiement",
        "es": "Pago",
        "zh": "支付",
        "ja": "支払い",
        "en": "Payment",
        "de": "Bezahlung",
        "it": "Pagamento",
        "ru": "Оплата",
        "tr": "Ödeme",
        "pt": "Pagamento",
        "th": "การชำระเงิน"
    },
    "카드 이름": {
        "ko": "카드 이름",
        "id": "Nama kartu",
        "fr": "Nom de la carte",
        "es": "Nombre de la tarjeta",
        "zh": "卡名",
        "ja": "カード名",
        "en": "Card name",
        "de": "Kartenname",
        "it": "Nome della carta",
        "ru": "Название карты",
        "tr": "Kart adı",
        "pt": "Nome do cartão",
        "th": "ชื่อบัตร"
    },
    "카드 번호": {
        "ko": "카드 번호",
        "id": "Nomor kartu",
        "fr": "Numéro de carte",
        "es": "Número de tarjeta",
        "zh": "卡号",
        "ja": "カード番号",
        "en": "Card number",
        "de": "Kartennummer",
        "it": "Numero della carta",
        "ru": "Номер карты",
        "tr": "Kart numarası",
        "pt": "Número do cartão",
        "th": "หมายเลขบัตร"
    },
    "유효 기간": {
        "ko": "유효 기간",
        "id": "Masa berlaku",
        "fr": "Date d'expiration",
        "es": "Fecha de caducidad",
        "zh": "有效期",
        "ja": "有効期限",
        "en": "Expiration date",
        "de": "Gültigkeitsdauer",
        "it": "Scadenza",
        "ru": "Срок действия",
        "tr": "Geçerlilik süresi",
        "pt": "Data de validade",
        "th": "วันที่หมดอายุ"
    },
    "전화번호": {
        "ko": "전화번호",
        "id": "Nomor telepon",
        "fr": "Numéro de téléphone",
        "es": "Número de teléfono",
        "zh": "电话号码",
        "ja": "電話番号",
        "en": "Phone number",
        "de": "Telefonnummer",
        "it": "Numero di telefono",
        "ru": "Номер телефона",
        "tr": "Telefon numarası",
        "pt": "Número de telefone",
        "th": "หมายเลขโทรศัพท์"
    },
    "카드 번호를 입력해주세요.": {
        "ko": "카드 번호를 입력해주세요.",
        "id": "Silakan masukkan nomor kartu Anda.",
        "fr": "Veuillez entrer votre numéro de carte.",
        "es": "Por favor, introduzca su número de tarjeta.",
        "zh": "请输入您的卡号。",
        "ja": "カード番号を入力してください。",
        "en": "Please enter your card number.",
        "de": "Bitte geben Sie Ihre Kartennummer ein.",
        "it": "Inserisci il numero della carta.",
        "ru": "Пожалуйста, введите номер карты.",
        "tr": "Lütfen kart numaranızı girin.",
        "pt": "Por favor, insira o número do seu cartão.",
        "th": "โปรดใส่หมายเลขบัตรของคุณ"
    },
    "카드 유효기간을 입력해주세요.": {
        "ko": "카드 유효기간을 입력해주세요.",
        "id": "Silakan masukkan masa berlaku kartu Anda.",
        "fr": "Veuillez entrer la date d'expiration de votre carte.",
        "es": "Por favor, introduzca la fecha de caducidad de su tarjeta.",
        "zh": "请输入您的卡有效期。",
        "ja": "カードの有効期限を入力してください。",
        "en": "Please enter your card expiration date.",
        "de": "Bitte geben Sie das Ablaufdatum Ihrer Karte ein.",
        "it": "Inserisci la data di scadenza della tua carta.",
        "ru": "Пожалуйста, введите срок действия вашей карты.",
        "tr": "Lütfen kartınızın geçerlilik süresini girin.",
        "pt": "Por favor, insira a data de validade do seu cartão.",
        "th": "โปรดใส่วันที่หมดอายุของบัตรของคุณ"
    },
    "이름을 입력해주세요.": {
        "ko": "이름을 입력해주세요.",
        "id": "Silakan masukkan nama Anda.",
        "fr": "Veuillez entrer votre nom.",
        "es": "Por favor, introduzca su nombre.",
        "zh": "请输入您的姓名。",
        "ja": "お名前を入力してください。",
        "en": "Please enter your name.",
        "de": "Bitte geben Sie Ihren Namen ein.",
        "it": "Inserisci il tuo nome.",
        "ru": "Пожалуйста, введите ваше имя.",
        "tr": "Lütfen adınızı girin.",
        "pt": "Por favor, insira seu nome.",
        "th": "โปรดใส่ชื่อของคุณ"
    },
    "전화번호를 입력해주세요.": {
        "ko": "전화번호를 입력해주세요.",
        "id": "Silakan masukkan nomor telepon Anda.",
        "fr": "Veuillez entrer votre numéro de téléphone.",
        "es": "Por favor, introduzca su número de teléfono.",
        "zh": "请输入您的电话号码。",
        "ja": "電話番号を入力してください。",
        "en": "Please enter your phone number.",
        "de": "Bitte geben Sie Ihre Telefonnummer ein.",
        "it": "Inserisci il tuo numero di telefono.",
        "ru": "Пожалуйста, введите ваш номер телефона.",
        "tr": "Lütfen telefon numaranızı girin.",
        "pt": "Por favor, insira seu número de telefone.",
        "th": "โปรดใส่หมายเลขโทรศัพท์ของคุณ"
    },
    "구매가 완료 되었습니다.": {
        "ko": "구매가 완료 되었습니다.",
        "id": "Pembelian telah selesai.",
        "fr": "L'achat est terminé.",
        "es": "La compra se ha completado.",
        "zh": "购买已完成。",
        "ja": "購入が完了しました。",
        "en": "Purchase completed.",
        "de": "Kauf abgeschlossen.",
        "it": "Acquisto completato.",
        "ru": "Покупка завершена.",
        "tr": "Satın alma işlemi tamamlandı.",
        "pt": "Compra concluída.",
        "th": "การซื้อเสร็จสมบูรณ์แล้ว"
    },
    "오류 발생. (비씨카드, 우리은행이라면 다른카드로 부탁드립니다.)": {
        "ko": "오류 발생. (비씨카드, 우리은행이라면 다른카드로 부탁드립니다.)",
        "id": "Terjadi kesalahan. (Jika menggunakan kartu BCA atau Bank Kami, harap gunakan kartu lain.)",
        "fr": "Erreur rencontrée. (Si vous utilisez une carte BCC ou une carte de notre banque, veuillez utiliser une autre carte.)",
        "es": "Se ha producido un error. (Si está utilizando una tarjeta BCC o de nuestro banco, por favor utilice otra tarjeta.)",
        "zh": "发生错误。(如果您使用的是BC卡或者我们的银行卡，请使用其他卡。)",
        "ja": "エラーが発生しました。(BCカード、または当社の銀行カードを使用している場合、別のカードをご利用ください。)",
        "en": "Error occurred. (If using BC Card or our bank's card, please use another card.)",
        "de": "Fehler aufgetreten. (Wenn Sie eine BC-Karte oder unsere Bankkarte verwenden, verwenden Sie bitte eine andere Karte.)",
        "it": "Errore durante l'operazione. (Se stai utilizzando una carta BCC o la nostra carta bancaria, utilizza un'altra carta.)",
        "ru": "Произошла ошибка. (Если вы используете карту BC или нашу банковскую карту, используйте другую карту.)",
        "tr": "Hata oluştu. (BC Kart veya bizim banka kartımızı kullanıyorsanız, lütfen başka bir kart kullanın.)",
        "pt": "Ocorreu um erro. (Se estiver usando um cartão BC ou nosso cartão de banco, por favor, use outro cartão.)",
        "th": "เกิดข้อผิดพลาด (หากใช้บัตร BC หรือบัตรของธนาคารของเรา โปรดใช้บัตรอื่น)"
    },
    "아이디 혹은 비밀번호가 다릅니다.": {
        "ko": "아이디 혹은 비밀번호가 다릅니다.",
        "id": "Username atau password salah.",
        "fr": "Identifiant ou mot de passe incorrect.",
        "es": "El usuario o la contraseña son incorrectos.",
        "zh": "用户名或密码错误。",
        "ja": "ユーザーIDまたはパスワードが違います。",
        "en": "Incorrect username or password.",
        "de": "Benutzername oder Passwort ist falsch.",
        "it": "Username o password errati.",
        "ru": "Неверное имя пользователя или пароль.",
        "tr": "Kullanıcı adı veya şifre yanlış.",
        "pt": "Nome de usuário ou senha incorretos.",
        "th": "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง"
    },
    "로그인": {
        "ko": "로그인",
        "id": "Masuk",
        "fr": "Connexion",
        "es": "Iniciar sesión",
        "zh": "登录",
        "ja": "ログイン",
        "en": "Login",
        "de": "Anmeldung",
        "it": "Accesso",
        "ru": "Вход",
        "tr": "Giriş",
        "pt": "Login",
        "th": "เข้าสู่ระบบ"
    },
    "비밀번호 찾기": {
        "ko": "비밀번호 찾기",
        "id": "Lupa kata sandi",
        "fr": "Mot de passe oublié",
        "es": "Recuperar contraseña",
        "zh": "找回密码",
        "ja": "パスワードをお忘れの場合",
        "en": "Forgot password",
        "de": "Passwort vergessen",
        "it": "Recupero password",
        "ru": "Забыли пароль",
        "tr": "Şifremi unuttum",
        "pt": "Esqueci minha senha",
        "th": "ลืมรหัสผ่าน"
    },
    "회원가입": {
        "ko": "회원가입",
        "id": "Pendaftaran",
        "fr": "Inscription",
        "es": "Registro",
        "zh": "注册",
        "ja": "会員登録",
        "en": "Sign up",
        "de": "Registrieren",
        "it": "Registrazione",
        "ru": "Регистрация",
        "tr": "Üye ol",
        "pt": "Cadastro",
        "th": "ลงทะเบียน"
    },
    "이메일": {
        "ko": "이메일",
        "id": "Email",
        "fr": "E-mail",
        "es": "Correo electrónico",
        "zh": "电子邮件",
        "ja": "メールアドレス",
        "en": "Email",
        "de": "E-Mail",
        "it": "Email",
        "ru": "Электронная почта",
        "tr": "E-posta",
        "pt": "E-mail",
        "th": "อีเมล"
    },
    "비밀번호": {
        "ko": "비밀번호",
        "id": "Kata sandi",
        "fr": "Mot de passe",
        "es": "Contraseña",
        "zh": "密码",
        "ja": "パスワード",
        "en": "Password",
        "de": "Passwort",
        "it": "Password",
        "ru": "Пароль",
        "tr": "Şifre",
        "pt": "Senha",
        "th": "รหัสผ่าน"
    },
    "이메일을 입력해주세요.": {
        "ko": "이메일을 입력해주세요.",
        "id": "Mohon masukkan email Anda.",
        "fr": "Veuillez entrer votre adresse e-mail.",
        "es": "Por favor, ingrese su correo electrónico.",
        "zh": "请输入您的电子邮件。",
        "ja": "メールアドレスを入力してください。",
        "en": "Please enter your email address.",
        "de": "Bitte geben Sie Ihre E-Mail-Adresse ein.",
        "it": "Inserisci il tuo indirizzo email.",
        "ru": "Пожалуйста, введите ваш адрес электронной почты.",
        "tr": "Lütfen e-posta adresinizi girin.",
        "pt": "Por favor, insira seu endereço de e-mail.",
        "th": "โปรดป้อนที่อยู่อีเมลของคุณ"
    },
    "인증코드를 입력해주세요.": {
        "ko": "인증코드를 입력해주세요.",
        "id": "Mohon masukkan kode verifikasi Anda.",
        "fr": "Veuillez saisir votre code de vérification.",
        "es": "Por favor, introduzca su código de verificación.",
        "zh": "请输入您的验证码。",
        "ja": "認証コードを入力してください。",
        "en": "Please enter your verification code.",
        "de": "Bitte geben Sie Ihren Bestätigungscode ein.",
        "it": "Inserisci il tuo codice di verifica.",
        "ru": "Пожалуйста, введите ваш проверочный код.",
        "tr": "Lütfen doğrulama kodunuzu girin.",
        "pt": "Por favor, insira seu código de verificação.",
        "th": "โปรดป้อนรหัสยืนยันของคุณ"
    },
    "연동된 이메일로 새로운 임시 비밀번호를 전달드립니다.": {
        "ko": "연동된 이메일로 새로운 임시 비밀번호를 전달드립니다.",
        "id": "Kami akan mengirimkan kata sandi sementara baru ke email yang terhubung.",
        "fr": "Nous vous enverrons un nouveau mot de passe temporaire à l'adresse e-mail associée.",
        "es": "Le enviaremos una nueva contraseña temporal al correo electrónico vinculado.",
        "zh": "我们将向关联的电子邮件发送新的临时密码。",
        "ja": "連携されたメールアドレス宛に新しい一時パスワードをお送りします。",
        "en": "We will send a new temporary password to your linked email.",
        "de": "Wir senden Ihnen ein neues temporäres Passwort an Ihre verknüpfte E-Mail-Adresse.",
        "it": "Invieremo una nuova password temporanea alla tua email collegata.",
        "ru": "Мы отправим новый временный пароль на вашу связанную электронную почту.",
        "tr": "Bağlı olduğunuz e-posta adresine yeni geçici bir şifre göndereceğiz.",
        "pt": "Enviaremos uma nova senha temporária para o seu email vinculado.",
        "th": "เราจะส่งรหัสผ่านชั่วคราวใหม่ไปยังอีเมลที่เชื่อมต่อ"
    },
    "이메일을 입력하세요.": {
        "ko": "이메일을 입력하세요.",
        "id": "Silakan masukkan email Anda.",
        "fr": "Veuillez saisir votre adresse e-mail.",
        "es": "Por favor, ingrese su correo electrónico.",
        "zh": "请输入您的电子邮件。",
        "ja": "メールアドレスを入力してください。",
        "en": "Please enter your email address.",
        "de": "Bitte geben Sie Ihre E-Mail-Adresse ein.",
        "it": "Inserisci il tuo indirizzo email.",
        "ru": "Пожалуйста, введите ваш адрес электронной почты.",
        "tr": "Lütfen e-posta adresinizi girin.",
        "pt": "Por favor, insira seu endereço de e-mail.",
        "th": "โปรดป้อนที่อยู่อีเมลของคุณ"
    },
    "인증코드를 입력하세요.": {
        "ko": "인증코드를 입력하세요.",
        "id": "Silakan masukkan kode verifikasi Anda.",
        "fr": "Veuillez saisir votre code de vérification.",
        "es": "Por favor, ingrese su código de verificación.",
        "zh": "请输入您的验证码。",
        "ja": "認証コードを入力してください。",
        "en": "Please enter your verification code.",
        "de": "Bitte geben Sie Ihren Bestätigungscode ein.",
        "it": "Inserisci il tuo codice di verifica.",
        "ru": "Пожалуйста, введите ваш проверочный код.",
        "tr": "Lütfen doğrulama kodunuzu girin.",
        "pt": "Por favor, insira seu código de verificação.",
        "th": "โปรดป้อนรหัสยืนยันของคุณ"
    },
    "오류 발생": {
        "ko": "오류 발생",
        "id": "Terjadi kesalahan",
        "fr": "Erreur rencontrée",
        "es": "Error encontrado",
        "zh": "发生错误",
        "ja": "エラーが発生しました",
        "en": "An error occurred",
        "de": "Es ist ein Fehler aufgetreten",
        "it": "Si è verificato un errore",
        "ru": "Произошла ошибка",
        "tr": "Bir hata oluştu",
        "pt": "Ocorreu um erro",
        "th": "เกิดข้อผิดพลาด"
    },
    "메일로 새로운 비밀번호를 전달하였습니다.": {
        "ko": "메일로 새로운 비밀번호를 전달하였습니다.",
        "id": "Kami telah mengirimkan kata sandi baru melalui email.",
        "fr": "Nous avons envoyé un nouveau mot de passe par email.",
        "es": "Hemos enviado una nueva contraseña por correo electrónico.",
        "zh": "我们已经通过电子邮件发送了新密码。",
        "ja": "新しいパスワードをメールで送信しました。",
        "en": "We have sent a new password via email.",
        "de": "Wir haben ein neues Passwort per E-Mail gesendet.",
        "it": "Abbiamo inviato una nuova password via email.",
        "ru": "Мы отправили новый пароль по электронной почте.",
        "tr": "Yeni bir şifre e-posta ile gönderdik.",
        "pt": "Enviamos uma nova senha por email.",
        "th": "เราได้ส่งรหัสผ่านใหม่ทางอีเมลแล้ว"
    },
    "보내기": {
        "ko": "보내기",
        "id": "Kirim",
        "fr": "Envoyer",
        "es": "Enviar",
        "zh": "发送",
        "ja": "送信",
        "en": "Send",
        "de": "Senden",
        "it": "Invia",
        "ru": "Отправить",
        "tr": "Gönder",
        "pt": "Enviar",
        "th": "ส่ง"
    },
    "인증하기": {
        "ko": "인증하기",
        "id": "Verifikasi",
        "fr": "Vérifier",
        "es": "Verificar",
        "zh": "认证",
        "ja": "認証する",
        "en": "Verify",
        "de": "Verifizieren",
        "it": "Verifica",
        "ru": "Подтвердить",
        "tr": "Doğrula",
        "pt": "Verificar",
        "th": "ตรวจสอบ"
    },
    "오류 발생. 다시 시도해주세요.": {
        "ko": "오류 발생. 다시 시도해주세요.",
        "id": "Terjadi kesalahan. Silakan coba lagi.",
        "fr": "Erreur rencontrée. Veuillez réessayer.",
        "es": "Se ha producido un error. Por favor, inténtelo de nuevo.",
        "zh": "出现错误。请重试。",
        "ja": "エラーが発生しました。もう一度お試しください。",
        "en": "An error occurred. Please try again.",
        "de": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
        "it": "Si è verificato un errore. Si prega di riprovare.",
        "ru": "Произошла ошибка. Пожалуйста, попробуйте снова.",
        "tr": "Bir hata oluştu. Lütfen tekrar deneyin.",
        "pt": "Ocorreu um erro. Por favor, tente novamente.",
        "th": "เกิดข้อผิดพลาด โปรดลองใหม่"
    },
    "실패 하셨습니다.": {
        "ko": "실패 하셨습니다.",
        "id": "Anda gagal.",
        "fr": "Vous avez échoué.",
        "es": "Ha fallado.",
        "zh": "您失败了。",
        "ja": "失敗しました。",
        "en": "You have failed.",
        "de": "Sie haben versagt.",
        "it": "Hai fallito.",
        "ru": "Вы провалились.",
        "tr": "Başarısız oldunuz.",
        "pt": "Você falhou.",
        "th": "คุณล้มเหลวแล้ว"
    },

    "이 정보 내용은 청소년 유해매체물로소 [정보통신망 이용 촉진 및 정보보호 등에 관환 법률] 및 [청소년 보호법] 의 규정에 의하여 19세 미만의 청소년이 이용할 수 없습니다.": {
        "ko": "이 정보 내용은 청소년 유해매체물로소 [정보통신망 이용 촉진 및 정보보호 등에 관환 법률] 및 [청소년 보호법] 의 규정에 의하여 19세 미만의 청소년이 이용할 수 없습니다.",
        "id": "Informasi ini adalah media berbahaya bagi pemuda dan tidak boleh digunakan oleh mereka yang berusia di bawah 19 tahun sesuai dengan ketentuan [Undang-Undang Promosi Pemanfaatan Informasi dan Jaringan Komunikasi serta Perlindungan Informasi, dll.] dan [Undang-Undang Perlindungan Pemuda].",
        "fr": "Ces informations sont des médias nocifs pour les jeunes et ne peuvent pas être utilisées par les jeunes de moins de 19 ans conformément aux dispositions de la [Loi sur la promotion de l'utilisation des réseaux de communication et la protection de l'information, etc.] et de la [Loi sur la protection de la jeunesse].",
        "es": "Esta información es un medio dañino para los jóvenes y no puede ser utilizada por menores de 19 años de acuerdo con las disposiciones de la [Ley de Promoción de la Utilización de la Información y las Comunicaciones en Red y Protección de la Información, etc.] y la [Ley de Protección de la Juventud].",
        "zh": "根据[信息和通信网络利用促进及信息保护等法]和[青少年保护法]的规定，本信息对青少年构成有害媒体，未满19岁的青少年不得使用。",
        "ja": "[情報通信網の利用促進及び情報保護等に関する法律]および[青少年保護法]の規定に基づき、この情報は青少年に有害なメディアであり、19歳未満の青少年は使用できません。",
        "en": "This information is harmful media for youth and cannot be used by youth under the age of 19 in accordance with the provisions of the [Act on Promotion of Information and Communications Network Utilization and Information Protection, etc.] and the [Youth Protection Act].",
        "de": "Diese Informationen sind schädliche Medien für Jugendliche und dürfen gemäß den Bestimmungen des [Gesetzes zur Förderung der Nutzung von Informations- und Kommunikationsnetzen sowie zum Schutz von Informationen usw.] und des [Jugendschutzgesetzes] nicht von Jugendlichen unter 19 Jahren genutzt werden.",
        "it": "Queste informazioni sono mezzi dannosi per i giovani e non possono essere utilizzate da giovani di età inferiore ai 19 anni in conformità alle disposizioni della [Legge sulla promozione dell'utilizzo delle reti di informazione e comunicazione e protezione delle informazioni, ecc.] e della [Legge sulla protezione dei giovani].",
        "ru": "Эта информация является вредными средствами массовой информации для молодежи и не может использоваться лицами моложе 19 лет в соответствии с положениями [Закона о поощрении использования информационно-коммуникационных сетей и защите информации и т. д.] и [Закона о защите молодежи].",
        "tr": "Bu bilgi gençler için zararlı bir medyadır ve [Bilgi ve İletişim Ağlarının Kullanımının Teşviki ve Bilgi Koruma vb. Kanun] ve [Gençleri Koruma Kanunu] hükümleri doğrultusunda 19 yaşın altındaki gençler tarafından kullanılamaz.",
        "pt": "Esta informação é mídia prejudicial para jovens e não pode ser utilizada por jovens menores de 19 anos, de acordo com as disposições da [Lei de Promoção da Utilização de Informações e Redes de Comunicação e Proteção da Informação, etc.] e da [Lei de Proteção à Juventude].",
        "th": "ข้อมูลนี้เป็นสื่อที่เสียหายต่อวัยรุ่นและไม่สามารถใช้ได้โดยผู้อายุต่ำกว่า 19 ปีตามกฎหมาย [พระราชบัญญัติส่งเสริมการใช้สารสนเทศและเครือข่ายโทรคมนาคมและการคุ้มครองข้อมูล ฯลฯ] และ [พระราชบัญญัติคุ้มครองเยาวชน]"
    },
    "19세 미만 나가기": {
        "ko": "19세 미만 나가기",
        "id": "Keluar bawah usia 19 tahun",
        "fr": "Sortir avant l'âge de 19 ans",
        "es": "Salir antes de los 19 años",
        "zh": "未满19岁不得离开",
        "ja": "19歳未満の退場",
        "en": "Exit under 19 years old",
        "de": "Verlassen unter 19 Jahren",
        "it": "Uscita sotto i 19 anni",
        "ru": "Выход до 19 лет",
        "tr": "19 yaşından küçük çıkış",
        "pt": "Sair com menos de 19 anos",
        "th": "ออกไปก่อนวัย 19 ปี"
    },
    "구글로 시작하기": {
        "ko": "구글로 시작하기",
        "id": "Mulai dengan Google",
        "fr": "Commencer avec Google",
        "es": "Comenzar con Google",
        "zh": "以谷歌开始",
        "ja": "Googleで始める",
        "en": "Start with Google",
        "de": "Beginnen Sie mit Google",
        "it": "Iniziare con Google",
        "ru": "Начните с Google",
        "tr": "Google ile başlamak",
        "pt": "Começar com o Google",
        "th": "เริ่มต้นด้วย Google"
    },
    "이메일로 시작하기": {
        "ko": "이메일로 시작하기",
        "id": "Mulai dengan email",
        "fr": "Commencer par email",
        "es": "Comenzar por correo electrónico",
        "zh": "通过电子邮件开始",
        "ja": "メールで始める",
        "en": "Start with email",
        "de": "Beginnen Sie mit E-Mail",
        "it": "Iniziare con l'email",
        "ru": "Начать с электронной почты",
        "tr": "E-posta ile başlamak",
        "pt": "Começar com e-mail",
        "th": "เริ่มต้นด้วยอีเมล"
    },
    "개인정보 처리방침": {
        "ko": "개인정보 처리방침",
        "id": "Kebijakan Perlindungan Data Pribadi",
        "fr": "Politique de confidentialité",
        "es": "Política de privacidad",
        "zh": "隐私政策",
        "ja": "プライバシーポリシー",
        "en": "Privacy Policy",
        "de": "Datenschutzrichtlinie",
        "it": "Informativa sulla privacy",
        "ru": "Политика конфиденциальности",
        "tr": "Gizlilik Politikası",
        "pt": "Política de Privacidade",
        "th": "นโยบายความเป็นส่วนตัว"
    },
    "이용약관": {
        "ko": "이용약관",
        "id": "Syarat Penggunaan",
        "fr": "Conditions d'utilisation",
        "es": "Términos de uso",
        "zh": "使用条款",
        "ja": "利用規約",
        "en": "Terms of Service",
        "de": "Nutzungsbedingungen",
        "it": "Condizioni d'uso",
        "ru": "Условия использования",
        "tr": "Kullanım Koşulları",
        "pt": "Termos de Serviço",
        "th": "ข้อกำหนดการใช้บริการ"
    },
    "회원가입시 엔픽스튜디오의 개인정보 처리방침과": {
        "ko": "회원가입시 엔픽스튜디오의 개인정보 처리방침과",
        "id": "Kebijakan Perlindungan Data Pribadi Enfix Studio saat Pendaftaran Anggota",
        "fr": "Politique de confidentialité d'Enfix Studio lors de l'inscription des membres",
        "es": "Política de privacidad de Enfix Studio al registrarse como miembro",
        "zh": "注册成为会员时，Enfix Studio 的个人信息处理政策",
        "ja": "会員登録時のEnfix Studioの個人情報保護方針と",
        "en": "Enfix Studio's Privacy Policy and Terms of Service at the time of registration",
        "de": "Datenschutzrichtlinie von Enfix Studio und Allgemeine Geschäftsbedingungen bei der Registrierung",
        "it": "Informativa sulla privacy di Enfix Studio e termini di servizio al momento della registrazione",
        "ru": "Политика конфиденциальности Enfix Studio и условия предоставления услуг при регистрации",
        "tr": "Üyelik kaydı sırasında Enfix Studio'nun Gizlilik Politikası ve Hizmet Şartları",
        "pt": "Política de Privacidade da Enfix Studio e Termos de Serviço no momento do cadastro",
        "th": "นโยบายความเป็นส่วนตัวของ Enfix Studio และเงื่อนไขการให้บริการในขณะที่ลงทะเบียน"
    },
    "이용약관에 동의하는걸로 간주합니다.": {
        "ko": "이용약관에 동의하는걸로 간주합니다.",
        "id": "Persetujuan Anda terhadap Syarat dan Ketentuan dianggap.",
        "fr": "Votre accord aux conditions d'utilisation est considéré.",
        "es": "Su consentimiento a los términos de uso se considera.",
        "zh": "您同意使用条款被视为。",
        "ja": "利用規約に同意したものとみなします。",
        "en": "Your agreement to the terms of use is considered.",
        "de": "Ihre Zustimmung zu den Nutzungsbedingungen gilt als gegeben.",
        "it": "Il tuo consenso alle condizioni di utilizzo è considerato.",
        "ru": "Ваше согласие с условиями использования считается.",
        "tr": "Kullanım koşullarını kabul ettiğiniz kabul edilir.",
        "pt": "O seu consentimento aos termos de uso é considerado.",
        "th": "การยินยอมของคุณต่อข้อกำหนดและเงื่อนไขถือว่าเป็นไปตามดังกล่าว"
    },
    "썸네일은 최대 5개 까지 업로드 가능합니다.": {
        "ko": "썸네일은 최대 5개 까지 업로드 가능합니다.",
        "id": "Thumbnail dapat diunggah hingga maksimal 5 gambar.",
        "fr": "Vous pouvez télécharger jusqu'à 5 miniatures.",
        "es": "Se pueden subir hasta 5 miniaturas.",
        "zh": "缩略图最多可以上传5张。",
        "ja": "サムネイルは最大5つまでアップロードできます。",
        "en": "You can upload up to 5 thumbnails.",
        "de": "Es können bis zu 5 Miniaturansichten hochgeladen werden.",
        "it": "È possibile caricare fino a 5 miniature.",
        "ru": "Можно загрузить до 5 миниатюр.",
        "tr": "En fazla 5 adet küçük resim yüklenebilir.",
        "pt": "É possível carregar até 5 miniaturas.",
        "th": "คุณสามารถอัปโหลดภาพตัวอย่างได้สูงสุด 5 รูป"
    },
    "썸네일을 골라주세요. (최대 5장)": {
        "ko": "썸네일을 골라주세요. (최대 5장)",
        "id": "Silahkan pilih thumbnail (maksimal 5 gambar)",
        "fr": "Veuillez choisir une vignette (maximum 5 images)",
        "es": "Por favor, elige una miniatura (máximo 5 imágenes)",
        "zh": "请选择缩略图（最多5张）",
        "ja": "サムネイルを選んでください（最大5枚）",
        "en": "Please choose a thumbnail (up to 5 images)",
        "de": "Bitte wählen Sie ein Vorschaubild aus (bis zu 5 Bilder)",
        "it": "Scegli un'immagine in anteprima (massimo 5 immagini)",
        "ru": "Выберите миниатюру (до 5 изображений)",
        "tr": "Lütfen bir önizleme resmi seçin (en fazla 5 resim)",
        "pt": "Por favor, escolha uma miniatura (até 5 imagens)",
        "th": "กรุณาเลือกรูปตัวอย่าง (สูงสุด 5 รูป)"
    },
    "구매시 다운받을 수 있는 ZIP 파일을 업로드 해주세요.": {
        "ko": "구매시 다운받을 수 있는 ZIP 파일을 업로드 해주세요.",
        "id": "Silakan unggah file ZIP yang dapat diunduh saat pembelian.",
        "fr": "Veuillez télécharger le fichier ZIP téléchargeable à l'achat.",
        "es": "Por favor, sube el archivo ZIP descargable al comprar.",
        "zh": "请上传购买时可下载的ZIP文件。",
        "ja": "購入時にダウンロード可能なZIPファイルをアップロードしてください。",
        "en": "Please upload the ZIP file that can be downloaded upon purchase.",
        "de": "Bitte laden Sie die ZIP-Datei hoch, die beim Kauf heruntergeladen werden kann.",
        "it": "Si prega di caricare il file ZIP scaricabile all'acquisto.",
        "ru": "Пожалуйста, загрузите ZIP-файл, который можно загрузить при покупке.",
        "tr": "Lütfen satın alındığında indirilebilen ZIP dosyasını yükleyin.",
        "pt": "Por favor, faça upload do arquivo ZIP que pode ser baixado após a compra.",
        "th": "กรุณาอัปโหลดไฟล์ ZIP ที่สามารถดาวน์โหลดได้หลังจากซื้อ"
    },
    "제목을 입력해주세요.": {
        "ko": "제목을 입력해주세요.",
        "id": "Silakan masukkan judul.",
        "fr": "Veuillez saisir un titre.",
        "es": "Por favor, introduzca un título.",
        "zh": "请输入标题。",
        "ja": "タイトルを入力してください。",
        "en": "Please enter a title.",
        "de": "Bitte geben Sie einen Titel ein.",
        "it": "Per favore, inserisci un titolo.",
        "ru": "Пожалуйста, введите заголовок.",
        "tr": "Lütfen bir başlık girin.",
        "pt": "Por favor, digite um título.",
        "th": "กรุณากรอกหัวข้อ"
    }, "가격을 설정해주세요!": {
        "ko": "가격을 설정해주세요!",
        "id": "Tolong tetapkan harga!",
        "fr": "Veuillez fixer le prix!",
        "es": "¡Por favor, establezca el precio!",
        "zh": "请设置价格！",
        "ja": "価格を設定してください！",
        "en": "Please set the price!",
        "de": "Bitte legen Sie den Preis fest!",
        "it": "Si prega di impostare il prezzo!",
        "ru": "Пожалуйста, установите цену!",
        "tr": "Lütfen fiyatı belirleyin!",
        "pt": "Por favor, defina o preço!",
        "th": "กรุณาตั้งราคา!"
    }
    , "금액을 입력해주세요.": {
        "ko": "금액을 입력해주세요.",
        "id": "Silakan masukkan jumlah.",
        "fr": "Veuillez entrer le montant.",
        "es": "Por favor, introduzca el importe.",
        "zh": "请输入金额。",
        "ja": "金額を入力してください。",
        "en": "Please enter the amount.",
        "de": "Bitte geben Sie den Betrag ein.",
        "it": "Si prega di inserire l'importo.",
        "ru": "Пожалуйста, введите сумму.",
        "tr": "Lütfen tutarı girin.",
        "pt": "Por favor, insira o valor.",
        "th": "กรุณาใส่จำนวนเงิน"
    }
    , "내용을 입력해주세요.": {
        "ko": "내용을 입력해주세요.",
        "id": "Silakan masukkan konten.",
        "fr": "Veuillez entrer le contenu.",
        "es": "Por favor, introduzca el contenido.",
        "zh": "请输入内容。",
        "ja": "内容を入力してください。",
        "en": "Please enter the content.",
        "de": "Bitte geben Sie den Inhalt ein.",
        "it": "Si prega di inserire il contenuto.",
        "ru": "Пожалуйста, введите содержимое.",
        "tr": "Lütfen içeriği girin.",
        "pt": "Por favor, insira o conteúdo.",
        "th": "กรุณาใส่เนื้อหา"
    }
    , "가격을 입력해주세요.": {
        "ko": "가격을 입력해주세요.",
        "id": "Silakan masukkan harga.",
        "fr": "Veuillez entrer le prix.",
        "es": "Por favor, introduzca el precio.",
        "zh": "请输入价格。",
        "ja": "価格を入力してください。",
        "en": "Please enter the price.",
        "de": "Bitte geben Sie den Preis ein.",
        "it": "Si prega di inserire il prezzo.",
        "ru": "Пожалуйста, введите цену.",
        "tr": "Lütfen fiyatı girin.",
        "pt": "Por favor, insira o preço.",
        "th": "กรุณาใส่ราคา"
    }
    , "ZIP 파일을 입력해주세요.": {
        "ko": "ZIP 파일을 입력해주세요.",
        "id": "Silakan masukkan file ZIP.",
        "fr": "Veuillez entrer le fichier ZIP.",
        "es": "Por favor, introduzca el archivo ZIP.",
        "zh": "请输入ZIP文件。",
        "ja": "ZIPファイルを入力してください。",
        "en": "Please enter the ZIP file.",
        "de": "Bitte geben Sie die ZIP-Datei ein.",
        "it": "Si prega di inserire il file ZIP.",
        "ru": "Пожалуйста, введите ZIP-файл.",
        "tr": "Lütfen ZIP dosyasını girin.",
        "pt": "Por favor, insira o arquivo ZIP.",
        "th": "กรุณาใส่ไฟล์ ZIP"
    }
    , "썸네일을 입력해주세요.": {
        "ko": "썸네일을 입력해주세요.",
        "id": "Silakan masukkan thumbnail.",
        "fr": "Veuillez entrer la vignette.",
        "es": "Por favor, introduzca la miniatura.",
        "zh": "请输入缩略图。",
        "ja": "サムネイルを入力してください。",
        "en": "Please enter the thumbnail.",
        "de": "Bitte geben Sie das Thumbnail ein.",
        "it": "Si prega di inserire la miniatura.",
        "ru": "Пожалуйста, введите миниатюру.",
        "tr": "Lütfen küçük resmi girin.",
        "pt": "Por favor, insira a miniatura.",
        "th": "กรุณาใส่ภาพขนาดย่อ"
    }
    , "업로드가 완료되었습니다.": {
        "ko": "업로드가 완료되었습니다.",
        "id": "Unggahan selesai.",
        "fr": "Le téléchargement est terminé.",
        "es": "La carga se ha completado.",
        "zh": "上传完成。",
        "ja": "アップロードが完了しました。",
        "en": "Upload completed.",
        "de": "Der Upload ist abgeschlossen.",
        "it": "Il caricamento è completato.",
        "ru": "Загрузка завершена.",
        "tr": "Yükleme tamamlandı.",
        "pt": "Carregamento concluído.",
        "th": "การอัปโหลดเสร็จสมบูรณ์"
    }
    , "업로드": {
        "ko": "업로드",
        "id": "Unggah",
        "fr": "Télécharger",
        "es": "Subir",
        "zh": "上传",
        "ja": "アップロード",
        "en": "Upload",
        "de": "Hochladen",
        "it": "Caricare",
        "ru": "Загрузить",
        "tr": "Yükle",
        "pt": "Carregar",
        "th": "อัปโหลด"
    }
    , "변경되었습니다.": {
        "ko": "변경되었습니다.",
        "id": "Telah diubah.",
        "fr": "C'est changé.",
        "es": "Ha sido cambiado.",
        "zh": "已更改。",
        "ja": "変更されました。",
        "en": "It has been changed.",
        "de": "Es wurde geändert.",
        "it": "È stato cambiato.",
        "ru": "Было изменено.",
        "tr": "Değiştirildi.",
        "pt": "Foi alterado.",
        "th": "มีการเปลี่ยนแปลง"
    }
    , "자기소개란을 입력해주세요.": {
        "ko": "자기소개란을 입력해주세요.",
        "id": "Silakan masukkan bagian perkenalan diri.",
        "fr": "Veuillez entrer la section de présentation.",
        "es": "Por favor, introduzca la sección de presentación.",
        "zh": "请输入自我介绍部分。",
        "ja": "自己紹介欄を入力してください。",
        "en": "Please enter the self-introduction section.",
        "de": "Bitte geben Sie den Selbstvorstellungsabschnitt ein.",
        "it": "Si prega di inserire la sezione di presentazione.",
        "ru": "Пожалуйста, введите раздел самопредставления.",
        "tr": "Lütfen kendinizi tanıtma bölümünü girin.",
        "pt": "Por favor, insira a seção de auto-apresentação.",
        "th": "กรุณาใส่ส่วนแนะนำตัว"
    }, "크리에이터 신청": {
        "ko": "크리에이터 신청",
        "id": "Aplikasi Kreator",
        "fr": "Demande de créateur",
        "es": "Solicitud de creador",
        "zh": "创作者申请",
        "ja": "クリエイター申請",
        "en": "Creator Application",
        "de": "Bewerbung als Ersteller",
        "it": "Domanda di creatore",
        "ru": "Заявка на создание",
        "tr": "Yaratıcı Başvurusu",
        "pt": "Aplicação de Criador",
        "th": "ใบสมัครผู้สร้าง"
    }
    , "프로필 설정": {
        "ko": "프로필 설정",
        "id": "Pengaturan Profil",
        "fr": "Paramètres de profil",
        "es": "Configuración de perfil",
        "zh": "配置文件设置",
        "ja": "プロフィール設定",
        "en": "Profile Settings",
        "de": "Profileinstellungen",
        "it": "Impostazioni del profilo",
        "ru": "Настройки профиля",
        "tr": "Profil Ayarları",
        "pt": "Configurações de Perfil",
        "th": "การตั้งค่าโปรไฟล์"
    }
    , "화보 상품 등록": {
        "ko": "화보 상품 등록",
        "id": "Pendaftaran Produk Album Foto",
        "fr": "Enregistrement du produit de photo",
        "es": "Registro de producto de álbum de fotos",
        "zh": "画报商品注册",
        "ja": "写真集商品登録",
        "en": "Photo Album Product Registration",
        "de": "Fotobuch-Produktregistrierung",
        "it": "Registrazione del prodotto dell'album fotografico",
        "ru": "Регистрация фотоальбома",
        "tr": "Fotoğraf Albümü Ürün Kaydı",
        "pt": "Registro de Produto de Álbum de Fotos",
        "th": "ลงทะเบียนสินค้าอัลบั้มภาพ"
    }
    , "내 수익": {
        "ko": "내 수익",
        "id": "Penghasilan Saya",
        "fr": "Mes revenus",
        "es": "Mis ingresos",
        "zh": "我的收益",
        "ja": "私の収益",
        "en": "My Earnings",
        "de": "Mein Einkommen",
        "it": "I miei guadagni",
        "ru": "Мой доход",
        "tr": "Gelirim",
        "pt": "Meus ganhos",
        "th": "รายได้ของฉัน"
    }
    ,
    "다운로드": {
        "ko": "다운로드",
        "id": "Unduh",
        "fr": "Télécharger",
        "es": "Descargar",
        "zh": "下载",
        "ja": "ダウンロード",
        "en": "Download",
        "de": "Herunterladen",
        "it": "Scarica",
        "ru": "Скачать",
        "tr": "İndir",
        "pt": "Baixar",
        "th": "ดาวน์โหลด"
    },
    "닉네임": {
        "ko": "닉네임",
        "id": "Nama Panggilan",
        "fr": "Surnom",
        "es": "Apodo",
        "zh": "昵称",
        "ja": "ニックネーム",
        "en": "Nickname",
        "de": "Spitzname",
        "it": "Soprannome",
        "ru": "Псевдоним",
        "tr": "Takma Ad",
        "pt": "Apelido",
        "th": "ชื่อเล่น"
    },
    "원하는 크리에이터 활동명을 입력해주세요.": {
        "ko": "원하는 크리에이터 활동명을 입력해주세요.",
        "id": "Silakan masukkan nama kreator yang diinginkan.",
        "fr": "Veuillez entrer le nom de créateur souhaité.",
        "es": "Por favor, introduzca el nombre del creador deseado.",
        "zh": "请输入所需的创作者名称。",
        "ja": "希望するクリエイター名を入力してください。",
        "en": "Please enter the desired creator name.",
        "de": "Bitte geben Sie den gewünschten Erstellernamen ein.",
        "it": "Si prega di inserire il nome del creatore desiderato.",
        "ru": "Пожалуйста, введите желаемое имя создателя.",
        "tr": "Lütfen istediğiniz yaratıcı adını girin.",
        "pt": "Por favor, insira o nome do criador desejado.",
        "th": "กรุณาใส่ชื่อผู้สร้างที่ต้องการ"
    },
    "프로필 링크": {
        "ko": "프로필 링크",
        "id": "Tautan Profil",
        "fr": "Lien de profil",
        "es": "Enlace de perfil",
        "zh": "个人资料链接",
        "ja": "プロフィールリンク",
        "en": "Profile Link",
        "de": "Profil-Link",
        "it": "Link al profilo",
        "ru": "Ссылка на профиль",
        "tr": "Profil Bağlantısı",
        "pt": "Link do Perfil",
        "th": "ลิงก์โปรไฟล์"
    }
    , "이름": {
        "ko": "이름",
        "id": "Nama",
        "fr": "Nom",
        "es": "Nombre",
        "zh": "名字",
        "ja": "名前",
        "en": "Name",
        "de": "Name",
        "it": "Nome",
        "ru": "Имя",
        "tr": "İsim",
        "pt": "Nome",
        "th": "ชื่อ"
    },
    "개인,회사 여부": {
        "ko": "개인,회사 여부",
        "id": "Pribadi atau Perusahaan",
        "fr": "Individu ou Entreprise",
        "es": "Individuo o Empresa",
        "zh": "个人或公司",
        "ja": "個人または会社",
        "en": "Individual or Company",
        "de": "Einzelperson oder Unternehmen",
        "it": "Individuale o Azienda",
        "ru": "Физическое лицо или компания",
        "tr": "Birey veya Şirket",
        "pt": "Indivíduo ou Empresa",
        "th": "บุคคลหรือบริษัท"
    },
    "개인": {
        "ko": "개인",
        "id": "Pribadi",
        "fr": "Individu",
        "es": "Individual",
        "zh": "个人",
        "ja": "個人",
        "en": "Individual",
        "de": "Einzelperson",
        "it": "Individuo",
        "ru": "Индивидуальный",
        "tr": "Bireysel",
        "pt": "Individual",
        "th": "บุคคล"
    },
    "작가": {
        "ko": "작가",
        "id": "Penulis",
        "fr": "Auteur",
        "es": "Autor",
        "zh": "作家",
        "ja": "作家",
        "en": "Author",
        "de": "Autor",
        "it": "Autore",
        "ru": "Автор",
        "tr": "Yazar",
        "pt": "Autor",
        "th": "นักเขียน"
    },
    "에이전시": {
        "ko": "에이전시",
        "id": "Agensi",
        "fr": "Agence",
        "es": "Agencia",
        "zh": "代理机构",
        "ja": "エージェンシー",
        "en": "Agency",
        "de": "Agentur",
        "it": "Agenzia",
        "ru": "Агентство",
        "tr": "Ajans",
        "pt": "Agência",
        "th": "เอเจนซี่"
    }
    , "회사": { "ko": "회사", "id": "Perusahaan", "fr": "Entreprise", "es": "Empresa", "zh": "公司", "ja": "会社", "en": "Company", "de": "Firma", "it": "Azienda", "ru": "Компания", "tr": "Şirket", "pt": "Empresa", "th": "บริษัท" },
    "SNS 주소": { "ko": "SNS 주소", "id": "Alamat SNS", "fr": "Adresse SNS", "es": "Dirección SNS", "zh": "SNS地址", "ja": "SNSアドレス", "en": "SNS Address", "de": "SNS-Adresse", "it": "Indirizzo SNS", "ru": "Адрес SNS", "tr": "SNS Adresi", "pt": "Endereço SNS", "th": "ที่อยู่ SNS" }, "PS. 전달하고싶은 말이 있으면 전달주세요": { "ko": "PS. 전달하고싶은 말이 있으면 전달주세요", "id": "PS. Jika ada pesan yang ingin disampaikan, silakan kirimkan", "fr": "PS. Si vous avez un message à transmettre, veuillez l'envoyer", "es": "PS. Si tiene algún mensaje que desea transmitir, por favor envíelo", "zh": "PS. 如果有要传达的话，请传达", "ja": "PS. 伝えたいことがあればお伝えください", "en": "PS. If you have something to convey, please let us know", "de": "PS. Wenn Sie etwas mitteilen möchten, teilen Sie es uns bitte mit", "it": "PS. Se hai qualcosa da comunicare, per favore fallo sapere", "ru": "PS. Если у вас есть что передать, пожалуйста, сообщите", "tr": "PS. İletmek istediğiniz bir şey varsa, lütfen iletin", "pt": "PS. Se tiver algo a comunicar, por favor, transmita", "th": "PS. หากคุณมีอะไรที่ต้องการจะบอก โปรดแจ้งให้เราทราบ" }, "sns 주소를 입력해주세요.": { "ko": "sns 주소를 입력해주세요.", "id": "Silakan masukkan alamat SNS.", "fr": "Veuillez entrer l'adresse SNS.", "es": "Por favor, introduzca la dirección SNS.", "zh": "请输入SNS地址。", "ja": "SNSアドレスを入力してください。", "en": "Please enter the SNS address.", "de": "Bitte geben Sie die SNS-Adresse ein.", "it": "Si prega di inserire l'indirizzo SNS.", "ru": "Пожалуйста, введите адрес SNS.", "tr": "Lütfen SNS adresini girin.", "pt": "Por favor, insira o endereço SNS.", "th": "กรุณาใส่ที่อยู่ SNS" }, "신청 완료 되었습니다.연락처로 곧 연락 드리겠습니다!": { "ko": "신청 완료 되었습니다.연락처로 곧 연락 드리겠습니다!", "id": "Aplikasi telah selesai. Kami akan segera menghubungi Anda melalui kontak!", "fr": "Votre demande est terminée. Nous vous contacterons bientôt!", "es": "La solicitud ha sido completada. Nos pondremos en contacto contigo pronto!", "zh": "申请已完成。我们会尽快与您联系！", "ja": "申請が完了しました。すぐに連絡いたします！", "en": "Application completed. We will contact you soon!", "de": "Die Bewerbung ist abgeschlossen. Wir werden Sie bald kontaktieren!", "it": "La domanda è completata. Ti contatteremo presto!", "ru": "Заявка завершена. Мы скоро свяжемся с вами!", "tr": "Başvuru tamamlandı. Yakında sizinle iletişime geçeceğiz!", "pt": "Inscrição concluída. Entraremos em contato em breve!", "th": "การสมัครเสร็จสมบูรณ์ เราจะติดต่อคุณเร็วๆ นี้!" }, "전송": { "ko": "전송", "id": "Kirim", "fr": "Envoyer", "es": "Enviar", "zh": "发送", "ja": "送信", "en": "Send", "de": "Senden", "it": "Inviare", "ru": "Отправить", "tr": "Gönder", "pt": "Enviar", "th": "ส่ง" }, "이번달 수익": { "ko": "이번달 수익", "id": "Pendapatan Bulan Ini", "fr": "Revenus de ce mois", "es": "Ingresos de este mes", "zh": "本月收入", "ja": "今月の収益", "en": "This Month's Earnings", "de": "Einkommen dieses Monats", "it": "Guadagni di questo mese", "ru": "Доходы за этот месяц", "tr": "Bu Ayın Kazancı", "pt": "Ganhos deste mês", "th": "รายได้เดือนนี้" }, "환전가능 수익(저번달 수익)": { "ko": "환전가능 수익(저번달 수익)", "id": "Pendapatan yang Dapat Ditukar (Pendapatan Bulan Lalu)", "fr": "Revenus échangeables (revenus du mois dernier)", "es": "Ingresos canjeables (ingresos del mes pasado)", "zh": "可兑换收入（上个月收入）", "ja": "両替可能な収益（先月の収益）", "en": "Exchangeable Earnings (Last Month's Earnings)", "de": "Umtauschbare Einnahmen (Einnahmen vom letzten Monat)", "it": "Guadagni Scambiabili (Guadagni del Mese Scorso)", "ru": "Доходы, доступные для обмена (Доходы за прошлый месяц)", "tr": "Değiştirilebilir Kazanç (Geçen Ayın Kazancı)", "pt": "Ganhos Conversíveis (Ganhos do Mês Passado)", "th": "รายได้ที่สามารถแลกเปลี่ยนได้ (รายได้เดือนที่แล้ว)" }, "수익은 익월 25일날 일괄 지급 됩니다.": { "ko": "수익은 익월 25일날 일괄 지급 됩니다.", "id": "Pendapatan akan dibayarkan secara keseluruhan pada tanggal 25 bulan berikutnya.", "fr": "Les revenus seront versés en une seule fois le 25 du mois suivant.", "es": "Los ingresos se pagarán en una sola vez el día 25 del mes siguiente.", "zh": "收入将于下月25日一次性支付。", "ja": "収益は翌月25日に一括支払いされます。", "en": "Earnings will be paid out in a lump sum on the 25th of the following month.", "de": "Die Einnahmen werden am 25. des folgenden Monats in einer Summe ausgezahlt.", "it": "I guadagni saranno pagati in un'unica soluzione il 25 del mese successivo.", "ru": "Доходы будут выплачены единовременно 25-го числа следующего месяца.", "tr": "Kazançlar ertesi ayın 25'inde toplu olarak ödenecektir.", "pt": "Os ganhos serão pagos em uma única vez no dia 25 do mês seguinte.", "th": "รายได้จะจ่ายเป็นก้อนในวันที่ 25 ของเดือนถัดไป" }, "개인 or 회사": { "ko": "개인 or 회사", "id": "Individu atau Perusahaan", "fr": "Individu ou Entreprise", "es": "Individuo o Empresa", "zh": "个人或公司", "ja": "個人または会社", "en": "Individual or Company", "de": "Einzelperson oder Unternehmen", "it": "Individuale o Azienda", "ru": "Физическое лицо или компания", "tr": "Birey veya Şirket", "pt": "Indivíduo ou Empresa", "th": "บุคคลหรือบริษัท" },
    "프리랜서 (개인)": {
        "ko": "프리랜서 (개인)",
        "id": "Freelancer (Individu)",
        "fr": "Freelance (Individu)",
        "es": "Freelancer (Individual)",
        "zh": "自由职业者（个人）",
        "ja": "フリーランサー（個人）",
        "en": "Freelancer (Individual)",
        "de": "Freiberufler (Einzelperson)",
        "it": "Freelancer (Individuale)",
        "ru": "Фрилансер (Индивидуальный)",
        "tr": "Freelancer (Bireysel)",
        "pt": "Freelancer (Individual)",
        "th": "ฟรีแลนซ์ (บุคคล)"
    },
    "사업자": {
        "ko": "사업자",
        "id": "Pengusaha",
        "fr": "Entrepreneur",
        "es": "Empresario",
        "zh": "企业主",
        "ja": "事業者",
        "en": "Business Owner",
        "de": "Unternehmer",
        "it": "Imprenditore",
        "ru": "Предприниматель",
        "tr": "İşletme Sahibi",
        "pt": "Empresário",
        "th": "ผู้ประกอบการ"
    },
    "주민등록번호": {
        "ko": "주민등록번호",
        "id": "Nomor Registrasi Penduduk",
        "fr": "Numéro d'enregistrement des résidents",
        "es": "Número de registro de residente",
        "zh": "居民登记号码",
        "ja": "住民登録番号",
        "en": "Resident Registration Number",
        "de": "Einwohnermelde-Nummer",
        "it": "Numero di registrazione del residente",
        "ru": "Номер регистрации жителя",
        "tr": "Kayıt Numarası",
        "pt": "Número de Registro de Residente",
        "th": "หมายเลขทะเบียนราษฎร์"
    },
    "사업자등록번호": {
        "ko": "사업자등록번호",
        "id": "Nomor Registrasi Bisnis",
        "fr": "Numéro d'enregistrement de l'entreprise",
        "es": "Número de registro de empresa",
        "zh": "企业注册号码",
        "ja": "事業者登録番号",
        "en": "Business Registration Number",
        "de": "Gewerberegistrierungsnummer",
        "it": "Numero di registrazione dell'azienda",
        "ru": "Регистрационный номер бизнеса",
        "tr": "İşletme Kayıt Numarası",
        "pt": "Número de Registro Empresarial",
        "th": "เลขทะเบียนธุรกิจ"
    }
    ,
    "실명 이름": {
        "ko": "실명 이름",
        "id": "Nama Asli",
        "fr": "Nom Réel",
        "es": "Nombre Real",
        "zh": "真实姓名",
        "ja": "実名",
        "en": "Real Name",
        "de": "Echter Name",
        "it": "Nome Reale",
        "ru": "Настоящее имя",
        "tr": "Gerçek İsim",
        "pt": "Nome Real",
        "th": "ชื่อจริง"
    },
    "회사명": {
        "ko": "회사명",
        "id": "Nama Perusahaan",
        "fr": "Nom de l'entreprise",
        "es": "Nombre de la empresa",
        "zh": "公司名称",
        "ja": "会社名",
        "en": "Company Name",
        "de": "Firmenname",
        "it": "Nome dell'azienda",
        "ru": "Название компании",
        "tr": "Şirket Adı",
        "pt": "Nome da Empresa",
        "th": "ชื่อบริษัท"
    },
    "계좌 은행 종류": {
        "ko": "계좌 은행 종류",
        "id": "Jenis Bank Akun",
        "fr": "Type de banque de compte",
        "es": "Tipo de banco de cuenta",
        "zh": "账户银行类型",
        "ja": "口座銀行の種類",
        "en": "Account Bank Type",
        "de": "Kontobanktyp",
        "it": "Tipo di Banca del Conto",
        "ru": "Тип банка счета",
        "tr": "Hesap Banka Türü",
        "pt": "Tipo de Banco da Conta",
        "th": "ประเภทธนาคารบัญชี"
    },
    "계좌 이름": {
        "ko": "계좌 이름",
        "id": "Nama Akun",
        "fr": "Nom du Compte",
        "es": "Nombre de la Cuenta",
        "zh": "账户名称",
        "ja": "口座名義",
        "en": "Account Name",
        "de": "Kontoname",
        "it": "Nome del Conto",
        "ru": "Название счета",
        "tr": "Hesap Adı",
        "pt": "Nome da Conta",
        "th": "ชื่อบัญชี"
    },
    "출금 계좌번호": {
        "ko": "출금 계좌번호",
        "id": "Nomor Rekening Penarikan",
        "fr": "Numéro de compte de retrait",
        "es": "Número de cuenta de retiro",
        "zh": "提款账户号码",
        "ja": "出金口座番号",
        "en": "Withdrawal Account Number",
        "de": "Auszahlungskontonummer",
        "it": "Numero di Conto di Prelievo",
        "ru": "Номер счета для снятия средств",
        "tr": "Para Çekme Hesap Numarası",
        "pt": "Número da Conta de Saque",
        "th": "หมายเลขบัญชีถอนเงิน"
    }
    ,
    "출금 계좌정보를 잘못기입시 환전 반려 처리됩니다. 정확한 정보 기입 바랍니다.": {
        "ko": "출금 계좌정보를 잘못기입시 환전 반려 처리됩니다. 정확한 정보 기입 바랍니다.",
        "id": "Penukaran akan ditolak jika informasi rekening penarikan diisi salah. Harap masukkan informasi yang benar.",
        "fr": "Le virement sera refusé si les informations du compte de retrait sont incorrectes. Veuillez entrer les informations correctes.",
        "es": "El cambio será rechazado si se ingresan incorrectamente los datos de la cuenta de retiro. Por favor, ingrese la información correcta.",
        "zh": "如果提款账户信息填写错误，将拒绝兑换。请填写正确的信息。",
        "ja": "出金口座情報の入力ミスがある場合、交換は拒否されます。正確な情報を入力してください。",
        "en": "The exchange will be rejected if the withdrawal account information is entered incorrectly. Please enter the correct information.",
        "de": "Die Auszahlung wird abgelehnt, wenn die Kontodaten falsch eingegeben werden. Bitte geben Sie die korrekten Informationen ein.",
        "it": "Il cambio verrà rifiutato se le informazioni del conto di prelievo sono inserite in modo errato. Si prega di inserire le informazioni corrette.",
        "ru": "Обмен будет отклонен, если информация о счете для снятия средств введена неправильно. Пожалуйста, введите правильную информацию.",
        "tr": "Para çekme hesap bilgileri yanlış girilirse, döviz bozdurma reddedilir. Lütfen doğru bilgileri giriniz.",
        "pt": "A troca será rejeitada se as informações da conta de saque forem inseridas incorretamente. Por favor, insira as informações corretas.",
        "th": "การแลกเปลี่ยนจะถูกปฏิเสธหากป้อนข้อมูลบัญชีถอนเงินไม่ถูกต้อง กรุณากรอกข้อมูลที่ถูกต้อง"
    },
    "등록 완료 되었습니다.": {
        "ko": "등록 완료 되었습니다.",
        "id": "Pendaftaran selesai.",
        "fr": "Inscription terminée.",
        "es": "Registro completado.",
        "zh": "注册完成。",
        "ja": "登録が完了しました。",
        "en": "Registration completed.",
        "de": "Registrierung abgeschlossen.",
        "it": "Registrazione completata.",
        "ru": "Регистрация завершена.",
        "tr": "Kayıt tamamlandı.",
        "pt": "Registro concluído.",
        "th": "การลงทะเบียนเสร็จสิ้น"
    },
    "등록": {
        "ko": "등록",
        "id": "Daftar",
        "fr": "S'inscrire",
        "es": "Registrarse",
        "zh": "注册",
        "ja": "登録",
        "en": "Register",
        "de": "Registrieren",
        "it": "Registrare",
        "ru": "Регистрация",
        "tr": "Kayıt",
        "pt": "Registrar",
        "th": "ลงทะเบียน"
    },
    "팔린 개수": {
        "ko": "팔린 개수",
        "id": "Jumlah Terjual",
        "fr": "Quantité vendue",
        "es": "Cantidad vendida",
        "zh": "售出数量",
        "ja": "販売数量",
        "en": "Quantity Sold",
        "de": "Verkaufte Menge",
        "it": "Quantità Venduta",
        "ru": "Проданное количество",
        "tr": "Satılan Miktar",
        "pt": "Quantidade Vendida",
        "th": "จำนวนที่ขายได้"
    },
    "로그아웃": {
        "ko": "로그아웃",
        "id": "Keluar",
        "fr": "Déconnexion",
        "es": "Cerrar sesión",
        "zh": "登出",
        "ja": "ログアウト",
        "en": "Logout",
        "de": "Abmelden",
        "it": "Disconnettersi",
        "ru": "Выйти",
        "tr": "Çıkış Yap",
        "pt": "Sair",
        "th": "ออกจากระบบ"
    },
    "크리에이터 탈퇴는 npickcompanystudio@gmail.com 으로 문의 부탁드립니다.": {
        "ko": "크리에이터 탈퇴는 npickcompanystudio@gmail.com 으로 문의 부탁드립니다.",
        "id": "Untuk berhenti sebagai kreator, silakan hubungi npickcompanystudio@gmail.com.",
        "fr": "Pour quitter le créateur, veuillez contacter npickcompanystudio@gmail.com.",
        "es": "Para dejar de ser creador, póngase en contacto con npickcompanystudio@gmail.com.",
        "zh": "要退出创作者，请联系 npickcompanystudio@gmail.com。",
        "ja": "クリエイター退会は npickcompanystudio@gmail.com までお問い合わせください。",
        "en": "To withdraw from being a creator, please contact npickcompanystudio@gmail.com.",
        "de": "Um als Creator auszutreten, kontaktieren Sie bitte npickcompanystudio@gmail.com.",
        "it": "Per ritirarsi come creatore, contattare npickcompanystudio@gmail.com.",
        "ru": "Для выхода из создателей, пожалуйста, свяжитесь с npickcompanystudio@gmail.com.",
        "tr": "Yaratıcı olmaktan vazgeçmek için lütfen npickcompanystudio@gmail.com ile iletişime geçin.",
        "pt": "Para deixar de ser um criador, entre em contato com npickcompanystudio@gmail.com.",
        "th": "หากต้องการยกเลิกการเป็นผู้สร้าง กรุณาติดต่อ npickcompanystudio@gmail.com"
    },
    "회원탈퇴시 구매한 내역이 전부 삭제 됩니다. 정말 탈퇴하시겠습니까?": {
        "ko": "회원탈퇴시 구매한 내역이 전부 삭제 됩니다. 정말 탈퇴하시겠습니까?",
        "id": "Semua riwayat pembelian akan dihapus jika Anda berhenti berlangganan. Apakah Anda yakin ingin berhenti berlangganan?",
        "fr": "Tous les historiques d'achat seront supprimés si vous vous désabonnez. Êtes-vous sûr de vouloir vous désabonner?",
        "es": "Todo el historial de compras se eliminará si cancela su suscripción. ¿Está seguro de que desea darse de baja?",
        "zh": "如果您取消订阅，所有购买历史记录将被删除。您确定要取消订阅吗？",
        "ja": "退会すると購入履歴がすべて削除されます。本当に退会しますか？",
        "en": "All purchase history will be deleted upon withdrawal. Are you sure you want to unsubscribe?",
        "de": "Beim Abmelden wird der gesamte Kaufverlauf gelöscht. Sind Sie sicher, dass Sie sich abmelden möchten?",
        "it": "Tutta la cronologia degli acquisti verrà eliminata al momento dell'annullamento dell'iscrizione. Sei sicuro di voler annullare l'iscrizione?",
        "ru": "Вся история покупок будет удалена при выходе. Вы уверены, что хотите отписаться?",
        "tr": "Üyelikten ayrıldığınızda tüm satın alma geçmişi silinecektir. Üyelikten ayrılmak istediğinizden emin misiniz?",
        "pt": "Todo o histórico de compras será excluído ao cancelar a inscrição. Tem certeza de que deseja cancelar a inscrição?",
        "th": "ประวัติการซื้อทั้งหมดจะถูกลบเมื่อคุณยกเลิกการเป็นสมาชิก คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการเป็นสมาชิก?"
    },
    "회원탈퇴": {
        "ko": "회원탈퇴",
        "id": "Berhenti Berlangganan",
        "fr": "Se désinscrire",
        "es": "Darse de baja",
        "zh": "取消订阅",
        "ja": "退会",
        "en": "Unsubscribe",
        "de": "Abmelden",
        "it": "Disiscriversi",
        "ru": "Отписаться",
        "tr": "Üyelikten Çık",
        "pt": "Cancelar inscrição",
        "th": "ยกเลิกการเป็นสมาชิก"
    }, "비밀번호 확인": {
        "ko": "비밀번호 확인", // 한국어
        "id": "Konfirmasi kata sandi", // 인도네시아어
        "fr": "Confirmation du mot de passe", // 프랑스어
        "es": "Confirmación de contraseña", // 스페인어
        "zh": "确认密码", // 중국어
        "ja": "パスワード確認", // 일본어
        "en": "Password confirmation", // 영어
        "de": "Passwort bestätigen", // 독일어
        "it": "Conferma password", // 이탈리아어
        "ru": "Подтверждение пароля", // 러시아어
        "tr": "Şifre onayı", // 터키어
        "pt": "Confirmação de senha", // 포르투갈어
        "th": "ยืนยันรหัสผ่าน", // 태국어
    }, "가입하기": {
        "ko": "가입하기", // 한국어
        "id": "Daftar", // 인도네시아어
        "fr": "S'inscrire", // 프랑스어
        "es": "Registrarse", // 스페인어
        "zh": "注册", // 중국어
        "ja": "登録する", // 일본어
        "en": "Sign up", // 영어
        "de": "Anmelden", // 독일어
        "it": "Iscriviti", // 이탈리아어
        "ru": "Зарегистрироваться", // 러시아어
        "tr": "Kayıt ol", // 터키어
        "pt": "Inscrever-se", // 포르투갈어
        "th": "สมัครสมาชิก", // 태국어
    }, "이메일이 발송되었습니다.": {
        "ko": "이메일이 발송되었습니다.", // 한국어
        "id": "Email telah dikirim.", // 인도네시아어
        "fr": "L'email a été envoyée.", // 프랑스어
        "es": "El correo electrónico ha sido enviado.", // 스페인어
        "zh": "邮件已发送。", // 중국어
        "ja": "メールが送信されました。", // 일본어
        "en": "The email has been sent.", // 영어
        "de": "Die E-Mail wurde gesendet.", // 독일어
        "it": "L'email è stata inviata.", // 이탈리아어
        "ru": "Электронное письмо было отправлено.", // 러시아어
        "tr": "E-posta gönderildi.", // 터키어
        "pt": "O email foi enviado.", // 포르투갈어
        "th": "อีเมลถูกส่งแล้ว", // 태국어
    }, "발송": {
        "ko": "발송", // 한국어
        "id": "Pengiriman", // 인도네시아어
        "fr": "Envoi", // 프랑스어
        "es": "Envío", // 스페인어
        "zh": "发送", // 중국어
        "ja": "発送", // 일본어
        "en": "Dispatch", // 영어
        "de": "Versand", // 독일어
        "it": "Invio", // 이탈리아어
        "ru": "Отправка", // 러시아어
        "tr": "Gönderim", // 터키어
        "pt": "Envio", // 포르투갈어
        "th": "การส่ง", // 태국어
    },
    "인증번호": {
        "ko": "인증번호", // 한국어
        "id": "Nomor verifikasi", // 인도네시아어
        "fr": "Code de vérification", // 프랑스어
        "es": "Código de verificación", // 스페인어
        "zh": "验证码", // 중국어
        "ja": "認証番号", // 일본어
        "en": "Verification code", // 영어
        "de": "Bestätigungscode", // 독일어
        "it": "Codice di verifica", // 이탈리아어
        "ru": "Код подтверждения", // 러시아어
        "tr": "Doğrulama kodu", // 터키어
        "pt": "Código de verificação", // 포르투갈어
        "th": "รหัสยืนยัน", // 태국어
    }, "인증 되었습니다.": {
        "ko": "인증 되었습니다.", // 한국어
        "id": "Telah diverifikasi.", // 인도네시아어
        "fr": "Vérifié.", // 프랑스어
        "es": "Verificado.", // 스페인어
        "zh": "已验证。", // 중국어
        "ja": "認証されました。", // 일본어
        "en": "Verified.", // 영어
        "de": "Verifiziert.", // 독일어
        "it": "Verificato.", // 이탈리아어
        "ru": "Проверено.", // 러시아어
        "tr": "Doğrulandı.", // 터키어
        "pt": "Verificado.", // 포르투갈어
        "th": "ยืนยันแล้ว", // 태국어
    }, "인증 번호가 다릅니다.": {
        "ko": "인증 번호가 다릅니다.", // 한국어
        "id": "Nomor verifikasi salah.", // 인도네시아어
        "fr": "Le code de vérification est incorrect.", // 프랑스어
        "es": "El código de verificación es incorrecto.", // 스페인어
        "zh": "验证码不正确。", // 중국어
        "ja": "認証番号が違います。", // 일본어
        "en": "The verification code is incorrect.", // 영어
        "de": "Der Bestätigungscode ist falsch.", // 독일어
        "it": "Il codice di verifica è errato.", // 이탈리아어
        "ru": "Код подтверждения неверен.", // 러시아어
        "tr": "Doğrulama kodu yanlış.", // 터키어
        "pt": "O código de verificação está incorreto.", // 포르투갈어
        "th": "รหัสยืนยันไม่ถูกต้อง", // 태국어
    }, "인증": {
        "ko": "인증", // 한국어
        "id": "Verifikasi", // 인도네시아어
        "fr": "Vérification", // 프랑스어
        "es": "Verificación", // 스페인어
        "zh": "认证", // 중국어
        "ja": "認証", // 일본어
        "en": "Verification", // 영어
        "de": "Verifizierung", // 독일어
        "it": "Verifica", // 이탈리아어
        "ru": "Верификация", // 러시아어
        "tr": "Doğrulama", // 터키어
        "pt": "Verificação", // 포르투갈어
        "th": "การยืนยัน", // 태국어
    }, "비밀번호를 입력해주세요.": {
        "ko": "비밀번호를 입력해주세요.", // 한국어
        "id": "Silakan masukkan kata sandi.", // 인도네시아어
        "fr": "Veuillez entrer le mot de passe.", // 프랑스어
        "es": "Por favor, ingrese la contraseña.", // 스페인어
        "zh": "请输入密码。", // 중국어
        "ja": "パスワードを入力してください。", // 일본어
        "en": "Please enter the password.", // 영어
        "de": "Bitte geben Sie das Passwort ein.", // 독일어
        "it": "Per favore, inserisci la password.", // 이탈리아어
        "ru": "Пожалуйста, введите пароль.", // 러시아어
        "tr": "Lütfen şifreyi giriniz.", // 터키어
        "pt": "Por favor, insira a senha.", // 포르투갈어
        "th": "กรุณาใส่รหัสผ่าน", // 태국어
    }, "이메일 인증을 해주세요.": {
        "ko": "이메일 인증을 해주세요.", // 한국어
        "id": "Silakan verifikasi email Anda.", // 인도네시아어
        "fr": "Veuillez vérifier votre e-mail.", // 프랑스어
        "es": "Por favor, verifique su correo electrónico.", // 스페인어
        "zh": "请验证您的电子邮件。", // 중국어
        "ja": "メールを認証してください。", // 일본어
        "en": "Please verify your email.", // 영어
        "de": "Bitte bestätigen Sie Ihre E-Mail.", // 독일어
        "it": "Si prega di verificare la tua email.", // 이탈리아어
        "ru": "Пожалуйста, подтвердите вашу почту.", // 러시아어
        "tr": "Lütfen e-postanızı doğrulayın.", // 터키어
        "pt": "Por favor, verifique seu e-mail.", // 포르투갈어
        "th": "โปรดยืนยันอีเมลของคุณ", // 태국어
    }, "비밀번호가 일치하지 않습니다.": {
        "ko": "비밀번호가 일치하지 않습니다.", // 한국어
        "id": "Password tidak cocok.", // 인도네시아어
        "fr": "Le mot de passe ne correspond pas.", // 프랑스어
        "es": "La contraseña no coincide.", // 스페인어
        "zh": "密码不匹配。", // 중국어
        "ja": "パスワードが一致しません。", // 일본어
        "en": "Password does not match.", // 영어
        "de": "Das Passwort stimmt nicht überein.", // 독일어
        "it": "La password non corrisponde.", // 이탈리아어
        "ru": "Пароль не совпадает.", // 러시아어
        "tr": "Şifre uyuşmuyor.", // 터키어
        "pt": "A senha não corresponde.", // 포르투갈어
        "th": "รหัสผ่านไม่ตรงกัน", // 태국어
    }, "오류 발생 다시 시도해주세요.": {
        "ko": "오류 발생 다시 시도해주세요.", // 한국어
        "id": "Terjadi kesalahan. Silakan coba lagi.", // 인도네시아어
        "fr": "Une erreur s'est produite. Veuillez réessayer.", // 프랑스어
        "es": "Se produjo un error. Por favor, inténtelo nuevamente.", // 스페인어
        "zh": "发生错误，请重试。", // 중국어
        "ja": "エラーが発生しました。もう一度お試しください。", // 일본어
        "en": "An error occurred. Please try again.", // 영어
        "de": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.", // 독일어
        "it": "Si è verificato un errore. Si prega di riprovare.", // 이탈리아어
        "ru": "Произошла ошибка. Пожалуйста, попробуйте еще раз.", // 러시아어
        "tr": "Bir hata oluştu. Lütfen tekrar deneyin.", // 터키어
        "pt": "Ocorreu um erro. Por favor, tente novamente.", // 포르투갈어
        "th": "เกิดข้อผิดพลาด โปรดลองอีกครั้ง", // 태국어
    }, "인증코드가 다릅니다.": {
        "ko": "인증코드가 다릅니다.", // 한국어
        "id": "Kode verifikasi salah.", // 인도네시아어
        "fr": "Le code de vérification est incorrect.", // 프랑스어
        "es": "El código de verificación es incorrecto.", // 스페인어
        "zh": "验证码不正确。", // 중국어
        "ja": "認証コードが違います。", // 일본어
        "en": "The verification code is incorrect.", // 영어
        "de": "Der Verifizierungscode ist falsch.", // 독일어
        "it": "Il codice di verifica è errato.", // 이탈리아어
        "ru": "Код подтверждения неверен.", // 러시아어
        "tr": "Doğrulama kodu yanlış.", // 터키어
        "pt": "O código de verificação está incorreto.", // 포르투갈어
        "th": "รหัสยืนยันไม่ถูกต้อง", // 태국어
    }, "라이브러리": {
        "ko": "라이브러리", // 한국어
        "id": "Perpustakaan", // 인도네시아어
        "fr": "Bibliothèque", // 프랑스어
        "es": "Biblioteca", // 스페인어
        "zh": "图书馆", // 중국어
        "ja": "ライブラリ", // 일본어
        "en": "Library", // 영어
        "de": "Bibliothek", // 독일어
        "it": "Libreria", // 이탈리아어
        "ru": "Библиотека", // 러시아어
        "tr": "Kütüphane", // 터키어
        "pt": "Biblioteca", // 포르투갈어
        "th": "ห้องสมุด", // 태국어
    }, "이미 가입된 계정이 있습니다.": {
        "ko": "이미 가입된 계정이 있습니다.", // 한국어
        "id": "Akun sudah terdaftar.", // 인도네시아어
        "fr": "Un compte est déjà enregistré.", // 프랑스어
        "es": "Ya existe una cuenta registrada.", // 스페인어
        "zh": "已有注册账户。", // 중국어
        "ja": "すでに登録されたアカウントがあります。", // 일본어
        "en": "An account is already registered.", // 영어
        "de": "Ein Konto ist bereits registriert.", // 독일어
        "it": "Esiste già un account registrato.", // 이탈리아어
        "ru": "Уже существует зарегистрированный аккаунт.", // 러시아어
        "tr": "Zaten kayıtlı bir hesap var.", // 터키어
        "pt": "Já existe uma conta registrada.", // 포르투갈어
        "th": "มีบัญชีที่สมัครไว้แล้ว", // 태국어
    }, "구글 로그인이 지원되지 않는 브라우저 입니다. 크롬, 사파리, 삼성인터넷 등 다른 브라우저에서 시도해보세요.": {
        "ko": "구글 로그인이 지원되지 않는 브라우저 입니다. 크롬, 사파리, 삼성인터넷 등 다른 브라우저에서 시도해보세요.",
        "id": "Ini adalah browser yang tidak mendukung login Google. Cobalah dengan browser lain seperti Chrome, Safari, atau Samsung Internet.",
        "fr": "Ce navigateur ne prend pas en charge la connexion Google. Veuillez essayer avec un autre navigateur tel que Chrome, Safari ou Samsung Internet.",
        "es": "Este navegador no es compatible con el inicio de sesión de Google. Intenta con otro navegador como Chrome, Safari o Samsung Internet.",
        "zh": "此浏览器不支持Google登录。请尝试使用其他浏览器，如Chrome、Safari或Samsung Internet。",
        "ja": "このブラウザはGoogleログインに対応していません。Chrome、Safari、Samsung Internetなどの別のブラウザでお試しください。",
        "en": "This browser does not support Google login. Please try another browser such as Chrome, Safari, or Samsung Internet.",
        "de": "Dieser Browser unterstützt kein Google-Login. Bitte versuchen Sie es mit einem anderen Browser wie Chrome, Safari oder Samsung Internet.",
        "it": "Questo browser non supporta l'accesso a Google. Prova un altro browser come Chrome, Safari o Samsung Internet.",
        "ru": "Этот браузер не поддерживает вход в Google. Попробуйте другой браузер, например Chrome, Safari или Samsung Internet.",
        "tr": "Bu tarayıcı Google girişini desteklemiyor. Lütfen Chrome, Safari veya Samsung Internet gibi başka bir tarayıcıda deneyin.",
        "pt": "Este navegador não suporta login do Google. Tente outro navegador como Chrome, Safari ou Samsung Internet.",
        "th": "เบราว์เซอร์นี้ไม่รองรับการเข้าสู่ระบบของ Google โปรดลองใช้เบราว์เซอร์อื่น เช่น Chrome, Safari หรือ Samsung Internet"
    }, "준비중 입니다!": {
        "ko": "준비중 입니다!",
        "id": "Sedang dipersiapkan!",
        "fr": "C'est en cours de préparation !",
        "es": "¡Está en preparación!",
        "zh": "准备中！",
        "ja": "準備中です！",
        "en": "Coming soon!",
        "de": "In Vorbereitung!",
        "it": "In preparazione!",
        "ru": "Готовится!",
        "tr": "Hazırlanıyor!",
        "pt": "Em preparação!",
        "th": "กำลังเตรียมการ!"
    }, "수정하기": {
        "ko": "수정하기",
        "id": "Mengedit",
        "fr": "Modifier",
        "es": "Editar",
        "zh": "编辑",
        "ja": "編集する",
        "en": "Edit",
        "de": "Bearbeiten",
        "it": "Modificare",
        "ru": "Редактировать",
        "tr": "Düzenle",
        "pt": "Editar",
        "th": "แก้ไข"
    }, "수정 완료되었습니다.": {
        "ko": "수정 완료되었습니다.",
        "id": "Perubahan selesai.",
        "fr": "Modification terminée.",
        "es": "Edición completada.",
        "zh": "修改完成。",
        "ja": "修正が完了しました。",
        "en": "Edit completed.",
        "de": "Änderung abgeschlossen.",
        "it": "Modifica completata.",
        "ru": "Изменение завершено.",
        "tr": "Düzenleme tamamlandı.",
        "pt": "Edição concluída.",
        "th": "แก้ไขเสร็จสิ้น."
    }, "· 어떠한 경우에도 환불이 불가능하니 신중히 구매해 주세요.": {
        "ko": "· 어떠한 경우에도 환불이 불가능하니 신중히 구매해 주세요.",
        "id": "· Pengembalian dana tidak mungkin dalam keadaan apapun, jadi harap pertimbangkan dengan hati-hati sebelum membeli.",
        "fr": "· Les remboursements sont impossibles dans tous les cas, veuillez donc acheter avec prudence.",
        "es": "· Los reembolsos no son posibles en ningún caso, así que por favor, compra con cuidado.",
        "zh": "· 在任何情况下都不可能退款，所以请慎重购买。",
        "ja": "· いかなる場合でも返金はできませんので、慎重に購入してください。",
        "en": "· Refunds are not possible under any circumstances, so please purchase carefully.",
        "de": "· Rückerstattungen sind unter keinen Umständen möglich, bitte kaufen Sie daher sorgfältig.",
        "it": "· I rimborsi non sono possibili in nessun caso, quindi si prega di acquistare con attenzione.",
        "ru": "· Возвраты невозможны при любых обстоятельствах, поэтому, пожалуйста, покупайте с осторожностью.",
        "tr": "· Herhangi bir durumda iade mümkün değildir, bu yüzden lütfen dikkatlice satın alın.",
        "pt": "· Os reembolsos não são possíveis em nenhuma circunstância, por favor, compre com cuidado.",
        "th": "· ไม่สามารถคืนเงินได้ในทุกกรณี กรุณาตัดสินใจซื้ออย่างระมัดระวัง"
    }, "· 등록한 카드로 결제되며 결제 이후 환불이 절대 불가능합니다.": {
        "ko": "· 등록한 카드로 결제되며 결제 이후 환불이 절대 불가능합니다.",
        "id": "· Pembayaran dilakukan dengan kartu terdaftar dan pengembalian dana tidak mungkin setelah pembayaran.",
        "fr": "· Le paiement est effectué avec la carte enregistrée et aucun remboursement n'est possible après le paiement.",
        "es": "· El pago se realiza con la tarjeta registrada y no es posible el reembolso después del pago.",
        "zh": "· 使用登记的信用卡支付，付款后绝不退款。",
        "ja": "· 登録したカードで決済され、決済後の返金は絶対にできません。",
        "en": "· Payment is made with the registered card and refunds are absolutely not possible after payment.",
        "de": "· Die Zahlung erfolgt mit der registrierten Karte und Rückerstattungen sind nach der Zahlung absolut nicht möglich.",
        "it": "· Il pagamento viene effettuato con la carta registrata e non è assolutamente possibile ottenere un rimborso dopo il pagamento.",
        "ru": "· Оплата производится зарегистрированной картой, и возврат денег после оплаты абсолютно невозможен.",
        "tr": "· Ödeme kayıtlı kartla yapılır ve ödeme sonrası iade kesinlikle mümkün değildir.",
        "pt": "· O pagamento é feito com o cartão registrado e os reembolsos não são possíveis após o pagamento.",
        "th": "· ชำระเงินด้วยบัตรที่ลงทะเบียนไว้ และไม่สามารถคืนเงินได้หลังจากชำระเงินแล้ว"
    }, "· 결제시 Dekina Pay의 이용약관에 동의하게 됩니다.": {
        "ko": "· 결제시 Dekina Pay의 이용약관에 동의하게 됩니다.",
        "id": "· Dengan melakukan pembayaran, Anda setuju dengan syarat dan ketentuan Dekina Pay.",
        "fr": "· En effectuant un paiement, vous acceptez les conditions d'utilisation de Dekina Pay.",
        "es": "· Al realizar el pago, usted acepta los términos y condiciones de Dekina Pay.",
        "zh": "· 付款时，您将同意Dekina Pay的使用条款。",
        "ja": "· 支払い時に、Dekina Payの利用規約に同意することになります。",
        "en": "· By making a payment, you agree to the terms and conditions of Dekina Pay.",
        "de": "· Durch die Zahlung stimmen Sie den Nutzungsbedingungen von Dekina Pay zu.",
        "it": "· Effettuando il pagamento, accetti i termini e le condizioni di Dekina Pay.",
        "ru": "· При оплате вы соглашаетесь с условиями использования Dekina Pay.",
        "tr": "· Ödeme yaparak, Dekina Pay'in kullanım koşullarını kabul etmiş olursunuz.",
        "pt": "· Ao efetuar o pagamento, você concorda com os termos e condições do Dekina Pay.",
        "th": "· เมื่อชำระเงินแล้ว แสดงว่าคุณยอมรับข้อกำหนดและเงื่อนไขของ Dekina Pay"
    }, "이 상품을 구매한 고객은 다음 상품도 구매했습니다.": {
        "ko": "이 상품을 구매한 고객은 다음 상품도 구매했습니다.",
        "id": "Pelanggan yang membeli produk ini juga membeli produk berikut.",
        "fr": "Les clients qui ont acheté ce produit ont également acheté les produits suivants.",
        "es": "Los clientes que compraron este producto también compraron los siguientes.",
        "zh": "购买此商品的客户还购买了以下商品。",
        "ja": "この商品を購入したお客様は、次の商品も購入しました。",
        "en": "Customers who bought this item also bought the following items.",
        "de": "Kunden, die dieses Produkt gekauft haben, kauften auch die folgenden Produkte.",
        "it": "I clienti che hanno acquistato questo prodotto hanno acquistato anche i seguenti articoli.",
        "ru": "Клиенты, купившие этот товар, также купили следующие товары.",
        "tr": "Bu ürünü satın alan müşteriler, aşağıdaki ürünleri de satın aldı.",
        "pt": "Os clientes que compraram este produto também compraram os seguintes.",
        "th": "ลูกค้าที่ซื้อสินค้านี้ยังซื้อสินค้าต่อไปนี้ด้วย"
    }, "구매시 다운받을수 있는 ZIP 파일을 업로드 해주세요.": {
        "ko": "구매시 다운받을수 있는 ZIP 파일을 업로드 해주세요.",
        "id": "Harap unggah file ZIP yang dapat diunduh saat pembelian.",
        "fr": "Veuillez télécharger le fichier ZIP téléchargeable lors de l'achat.",
        "es": "Por favor, suba el archivo ZIP que se puede descargar al realizar la compra.",
        "zh": "请上传购买时可下载的ZIP文件。",
        "ja": "購入時にダウンロードできるZIPファイルをアップロードしてください。",
        "en": "Please upload the ZIP file that can be downloaded upon purchase.",
        "de": "Bitte laden Sie die ZIP-Datei hoch, die beim Kauf heruntergeladen werden kann.",
        "it": "Si prega di caricare il file ZIP che può essere scaricato al momento dell'acquisto.",
        "ru": "Пожалуйста, загрузите ZIP-файл, который можно скачать при покупке.",
        "tr": "Satın alma sırasında indirilebilecek ZIP dosyasını yükleyin.",
        "pt": "Por favor, faça o upload do arquivo ZIP que pode ser baixado na compra.",
        "th": "โปรดอัปโหลดไฟล์ ZIP ที่สามารถดาวน์โหลดได้เมื่อซื้อ"
    }, "다운로드는 5회 까지 가능합니다.": {
        "ko": "다운로드는 5회 까지 가능합니다.",
        "id": "Unduhan bisa dilakukan hingga 5 kali.",
        "fr": "Le téléchargement est possible jusqu'à 5 fois.",
        "es": "Las descargas son posibles hasta 5 veces.",
        "zh": "下载最多可进行5次。",
        "ja": "ダウンロードは5回まで可能です。",
        "en": "Downloads are limited to 5 times.",
        "de": "Downloads sind bis zu 5 Mal möglich.",
        "it": "I download sono limitati a 5 volte.",
        "ru": "Скачивание возможно до 5 раз.",
        "tr": "İndirme işlemi 5 kez ile sınırlıdır.",
        "pt": "Os downloads são limitados a 5 vezes.",
        "th": "ดาวน์โหลดได้สูงสุด 5 ครั้ง"
    }, "금액은 100원 이상으로 하셔야 합니다.": {
        "ko": "금액은 100원 이상으로 하셔야 합니다.",
        "id": "Jumlahnya harus minimal 100 won.",
        "fr": "Le montant doit être d'au moins 100 wons.",
        "es": "La cantidad debe ser de al menos 100 won.",
        "zh": "金额必须在100韩元以上。",
        "ja": "金額は100ウォン以上にする必要があります。",
        "en": "The amount must be at least 100 won.",
        "de": "Der Betrag muss mindestens 100 Won betragen.",
        "it": "L'importo deve essere di almeno 100 won.",
        "ru": "Сумма должна быть не менее 100 вон.",
        "tr": "Tutar en az 100 won olmalıdır.",
        "pt": "O valor deve ser de pelo menos 100 won.",
        "th": "จำนวนเงินต้องไม่น้อยกว่า 100 วอน"
    }


    /*,"": {
        "ko": "",
        "id": "",
        "fr": "",
        "es": "",
        "zh": "",
        "ja":"",
        "en": "",
        "de": "",
        "it": "",
        "ru": "",
        "tr":"",
        "pt": "",
        "th": "",
    }*/


}


const Translator = (str: string, country: string) => {
    if (languagePack[str.trim()]) return languagePack[str.trim()][country]
    else return ''
}



export {
    Translator,
}